/**
 * Canarytoken-Generator (öffentliches Tool). Spricht den ratenbegrenzten
 * /pub/-Endpunkt des Canary-Dienstes an (siehe aroundsec-canary). Erzeugt eine
 * Köderdatei, die beim Öffnen Alarm an Ersteller + aroundsec sendet.
 */
(function () {
    'use strict';
    var form = document.querySelector('[data-canary-form]');
    if (!form) { return; }
    var out = form.querySelector('[data-canary-out]');
    var btn = form.querySelector('[data-canary-submit]');

    function esc(s) {
        return (s || '').replace(/[&<>"']/g, function (c) {
            return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c];
        });
    }
    function msg(kind, html) { out.className = 'canary-msg is-' + kind; out.innerHTML = html; }

    form.addEventListener('submit', function (e) {
        e.preventDefault();
        var label = form.querySelector('#canary-label').value.trim();
        var email = form.querySelector('#canary-email').value.trim();
        var tos = form.querySelector('#canary-tos').checked;
        if (!tos) { msg('error', 'Bitte die Nutzungsbedingungen bestätigen.'); return; }
        if (email.indexOf('@') < 0) { msg('error', 'Bitte eine gültige E-Mail angeben.'); return; }

        btn.disabled = true;
        msg('loading', 'Köder wird erzeugt …');
        fetch('/pub/create', {
            method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({Label: label, Email: email, Tos: tos})
        })
            .then(function (r) {
                if (!r.ok) { return r.text().then(function (t) { throw new Error(t || 'Fehler'); }); }
                return r.json();
            })
            .then(function (d) {
                msg('success', '<strong>Köder erzeugt – der Download startet gleich.</strong><br>' +
                    'Lege die Datei dort ab, wo ein Angreifer sie vermuten würde (z.&nbsp;B. auf einem ' +
                    'Dateiserver). Wird sie geöffnet, bekommen <em>' + esc(email) + '</em> und aroundsec ' +
                    'sofort eine Warn-E-Mail mit Zeitpunkt, IP und Programm des Öffnenden.');
                window.location = d.xlsx;
                btn.disabled = false;
            })
            .catch(function (err) {
                msg('error', esc(err.message || 'Es ist ein Fehler aufgetreten.'));
                btn.disabled = false;
            });
    });
})();
